import axios from 'axios';
import { message } from 'antd';

const api = axios.create({
  withCredentials: true,
  timeout: 30000,
});

// Request interceptor - add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('username');
      localStorage.removeItem('roleType');
      localStorage.removeItem('permissions');

      message.error('Your session has expired. Please login again.');

      setTimeout(() => {
        window.location.href = '/login';
      }, 1500);

      return Promise.reject(new Error('Unauthorized - redirecting to login'));
    }

    return Promise.reject(error);
  }
);

export default api;
